export const NUCLICORE_PLATFORM_API_ENDPONT = 'https://api.nuclicore.com';

// Resource Paths
export const AI_COPILOT_RESOURCE_PATH = '/ec6d9dce-3f04-4790-91c5-412758da0d2a';
